import PropTypes from 'prop-types';
import React from 'react';
import { withI18n } from 'lingui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import {
  addPageToBreadcrumbs,
  setLoadingStarted,
} from 'redux/app/actions';
import {
  loadCase,
  setCurrentCase,
} from 'redux/cases/actions';
import {
  currentCaseSelector,
  loadCaseErrorSelector,
} from 'redux/cases/selectors';

import immutableToJS from 'utils/immutableToJS';

import Component from './Component';

/* istanbul ignore next */
const withCaseDetailData = (DetailsPage) => {
  function WithCaseDetailData(props) {
    return (
      <Component {...props} ChildComponent={DetailsPage} />
    );
  }

  WithCaseDetailData.propTypes = {
    addPageToBreadcrumbs: PropTypes.func.isRequired,
    caseError: PropTypes.shape({
      error: PropTypes.oneOf([true]).isRequired,
    }),
    caseInfo: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: PropTypes.object.isRequired,
    i18n: PropTypes.shape({
      _: PropTypes.func.isRequired,
    }).isRequired,
    loadCase: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    setCurrentCase: PropTypes.func.isRequired,
    setLoadingStarted: PropTypes.func.isRequired,
  };

  WithCaseDetailData.defaultProps = {
    caseError: undefined,
  };

  function mapStateToProps(state) {
    return {
      caseError: loadCaseErrorSelector(state),
      caseInfo: currentCaseSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: breadcrumbs => dispatch(addPageToBreadcrumbs(breadcrumbs)),
      loadCase: caseId => dispatch(loadCase({ caseId })),
      setCurrentCase: caseId => dispatch(setCurrentCase(caseId)),
      setLoadingStarted: () => dispatch(setLoadingStarted(true)),
    };
  }

  return compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withI18n(),
    immutableToJS,
  )(WithCaseDetailData);
};

export default withCaseDetailData;



// WEBPACK FOOTER //
// ./containers/CaseDetailData/index.js